import React, { useEffect, useMemo, useState } from 'react';
import styles from './CreateCampaign.module.scss';
import AuthLayout from '../../../Layouts/AuthLayout/AuthLayout';
import SettingsHeader from '../../../Components/SettingsHeader/SettingsHeader';
import { Button, Col, Image, Row, Select, Modal, notification } from 'antd';
import cc from 'classnames';
import '../override.scss';
import { useDispatch, useSelector } from 'react-redux';
import InputText from '../../../Components/Commons/InputText/InputText';
import { EditOutlined } from '@ant-design/icons';
import validator from 'validator';
import countryList from 'react-select-country-list';
import { getAccounts, resetAccountDetails } from '../../../Redux/Features/getAccountsSlice';
import { getCompanies, resetCompanyDetails } from '../../../Redux/Features/getCompaniesSlice';
import { getAllProductsToDisplay, getCookie, removeCookie, removeDuplicates } from '../../../utils/helper';
import { createCampaign } from '../../../Redux/Features/createCampaignSlice';
import { useNavigate } from 'react-router-dom';
import FilterElement from '../../../Components/Campaigns/FilterElement/FilterElement';
import TargetElement from '../../../Components/Campaigns/TargetElement/TargetElement';
import { Error } from '../../../Components/Commons/Message/Message';

const CreateCampaign = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.user);
  const { profiles } = useSelector((state) => state?.getLinkedinProfiles);
  const { isLoading: createCampaignLoading } = useSelector((state) => state?.createCampaign);
  const { campaigns: allCampaigns } = useSelector((state) => state?.getCampaigns);
  const { details: accountsDetails, isLoading: getAccountsLoading } = useSelector((state) => state?.getAccounts);
  const { details: companiesDetails, isLoading: getCompaniesLoading } = useSelector((state) => state?.getCompanies);
  const { products } = useSelector((state) => state?.getProducts);
  const countryOptions = useMemo(() => countryList().getData(), []);
  const [clientError, setClientError] = useState({});
  const [isTitleEditable, setIsTitleEditable] = useState(false);
  const [parametersModalOpen, setParametersModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: 'Campaign One',
    linkedin_account: '',
    business_page: {
      label: '',
      value: '',
    },
    locations: {
      include: undefined,
      is_disabled: true,
      items: [],
    },
    hashtags: {
      items: [],
    },
    accounts: { items: [] },
    pages: { items: [] },
    product_id: '',
  });

  const setField = (feildName, feildValue) => {
    setFormData({ ...formData, [feildName]: feildValue });
  };

  useEffect(() => {
    dispatch(resetAccountDetails());
    dispatch(resetCompanyDetails());
  }, []);

  const linkedinAllAccountsHandler = () => {
    const copyProfiles = [...profiles];
    const newProfilesOptionsArr = [];
    copyProfiles?.filter((item, i) => newProfilesOptionsArr?.push({ value: item?._id, label: item?.linkedin_name }));
    return newProfilesOptionsArr[0] ? newProfilesOptionsArr : [];
  };


  const businessPagesHandler = (val) => {
    let copyProfiles = [...profiles];
    const newProfilesOptionsArr = [];
    copyProfiles = copyProfiles?.find((item, i) => item?._id === formData?.linkedin_account);
    copyProfiles?.business_pages?.filter((item, i) =>
      newProfilesOptionsArr?.push({ label: item?.name, value: item?.value })
    );
    if (val) {
      copyProfiles = copyProfiles?.business_pages?.find((item, i) => item?.value === val);
      return copyProfiles !== undefined ? { ...copyProfiles, value: copyProfiles?.value } : {};
    }
    return newProfilesOptionsArr[0] ? newProfilesOptionsArr : [];
  };

  const handleCreateCampaign = async (isDraft = false) => {
    let isErr = false;
    let errors = {};

    if (validator.isEmpty(formData?.title)) {
      isErr = true;
      errors.title = 'Title is required';
    }
    if (validator.isEmpty(formData?.linkedin_account)) {
      isErr = true;
      errors.linkedin_account = 'Linkedin account is required';
    }
    if (validator.isEmpty(formData?.business_page?.value?.toString())) {
      isErr = true;
      errors.business_page = 'Business page is required';
    }
    if (!isDraft && validator.isEmpty(formData?.product_id)) {
      isErr = true;
      errors.product_id = 'Please choose a subscription plan';
    }

    if (isErr) {
      isErr = false;
      setClientError(errors);
      for (let key in errors) {
        Error(errors[key], 2);
      }
    } else {
      setClientError({});
      let copyFormData = {
        ...formData,
        accounts: { ...formData?.accounts, items: removeDuplicates(formData?.accounts?.items, 'id') },
        pages: { ...formData?.pages, items: removeDuplicates(formData?.pages?.items, 'id') },
        hashtags: { ...formData?.hashtags, items: removeDuplicates(formData?.hashtags?.items) },
        isDraft
      };

      dispatch(
        createCampaign({
          data: copyFormData,
          onSuccess: (sessionUrl) => {
            if (user?.role === 'INTERNAL' || isDraft) {
              navigate('/campaigns');
            } else {
              window.location = sessionUrl;
            }
          },
        })
      );
    }
  };

  const handleGetActiveCampaigns = () => {
    let copyAllCampaigns = [...allCampaigns];
    const campaignsActive = copyAllCampaigns?.filter(
      (item, i) => item?.is_active && item?.status === 'Active'
    );
    return campaignsActive[0] ? campaignsActive : [];
  };

  const handleLoadParamters = (campaign) => {
    const { locations, accounts, pages, hashtags } = campaign;
    setFormData({ ...formData, locations, accounts, pages, hashtags });
    setParametersModalOpen(false);
  };
  const handleCountries = () => {
    const copyCountryOptions = [...countryOptions];
    let newCountryList = [];
    copyCountryOptions?.filter((item, i) => newCountryList?.push({ value: item?.label, label: item?.label }));
    return newCountryList[0] ? newCountryList : [];
  };
  const handleAccountsDetails = (value) => {
    if (getAccountsLoading) return;
    if (!formData?.linkedin_account) {
      notification.error({ message: 'Error', description: 'Linkedin account not selected' });
    } else {
      dispatch(getAccounts({ id: formData?.linkedin_account, data: value }));
    }
  };

  const handlePagesDetails = (value) => {
    if (getCompaniesLoading) return;

    if (!formData?.linkedin_account) {
      notification.error({ message: 'Error', description: 'Linkedin account not selected' });
    } else {
      dispatch(getCompanies({ id: formData?.linkedin_account, data: value }));
    }
  };
  return (
    <AuthLayout>
      <SettingsHeader
        content={
          <div className={styles.profile_setting_container}>
            <div className={styles.profile_details}>
              <h5>Campaigns</h5>

              {isTitleEditable ? (
                <div className={styles.input_container}>
                  <InputText
                    size={'medium'}
                    placeholder={'Enter campaign name'}
                    value={formData?.title}
                    onChange={(e) => setField('title', e?.target?.value)}
                    onPressEnter={() => formData?.title !== '' && setIsTitleEditable(false)}
                    error={clientError?.title ? clientError?.title : false}
                  />
                </div>
              ) : (
                <h2>
                  {formData?.title}
                  <EditOutlined onClick={() => setIsTitleEditable(true)} />
                </h2>
              )}
            </div>
            <div className={styles.details}>
              <div className={styles.linkedin_account}>
                <p>Linkedin accounts</p>
                <Select
                  className="select_container"
                  defaultValue={'All Accounts'}
                  options={linkedinAllAccountsHandler()}
                  onChange={(val) =>
                    setFormData({ ...formData, linkedin_account: val, business_page: { label: '', value: '' } })
                  }
                  value={formData?.linkedin_account ? formData?.linkedin_account : undefined}
                  suffixIcon={<Image src={'/Assets/arrow_select_icon.svg'} alt={'arrow icon'} preview={false} />}
                  status={clientError?.linkedin_account && 'error'}
                  style={{
                    width: 136.36,
                  }}
                />
              </div>
              <div className={styles.business_page}>
                <p>Business page</p>
                <Select
                  className="select_container"
                  defaultValue={'Select'}
                  options={businessPagesHandler()}
                  onChange={(val) => setField('business_page', businessPagesHandler(val))}
                  value={formData?.business_page?.value ? formData?.business_page?.value : undefined}
                  suffixIcon={<Image src={'/Assets/arrow_select_icon.svg'} alt={'arrow icon'} preview={false} />}
                  status={clientError?.business_page && 'error'}
                  style={{
                    width: 136.36,
                  }}
                />
              </div>
            </div>
          </div>
        }
      />

      <div className={cc(styles.main_campaign_details_container, 'main_create_campaign_details_container')}>
        <div className={styles.targets_container}>
          <h2>Targets</h2>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={24} md={12}>
              <TargetElement
                title={'Hashtags'}
                description={''}
                tagClassName={'tag_purple'}
                inputClassName={'input_purple'}
                type={'input'}
                onSuccess={(data) => setField('hashtags', data)}
                data={formData?.hashtags}
                error={clientError?.hashtags && clientError?.hashtags}
              />
            </Col>
            <Col xs={24} sm={24} md={12}>
              <TargetElement
                title={'Accounts'}
                description={''}
                tagClassName={'tag_yellow'}
                inputClassName={'input_yellow'}
                type={'select'}
                onSuccess={(data) => setField('accounts', data)}
                data={formData?.accounts}
                selectOptions={accountsDetails}
                onSelectSearchEnter={(val) => handleAccountsDetails(val)}
                selectLoading={getAccountsLoading}
                error={clientError?.accounts && clientError?.accounts}
                onSelectClear={() => dispatch(resetAccountDetails())}
              />
            </Col>
            <Col xs={24} sm={24} md={12}>
              <TargetElement
                title={'Pages'}
                description={''}
                tagClassName={'tag_green'}
                inputClassName={'input_green'}
                type={'select'}
                onSuccess={(data) => setField('pages', data)}
                data={formData?.pages}
                selectOptions={companiesDetails[0] ? companiesDetails : []}
                onSelectSearchEnter={(val) => handlePagesDetails(val)}
                selectLoading={getCompaniesLoading}
                error={clientError?.pages && clientError?.pages}
                onSelectClear={() => dispatch(resetCompanyDetails())}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.filters_container}>
          <h2>Filters</h2>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={24} md={12}>
              <FilterElement
                title={'Locations'}
                description={''}
                tagClassName={'tag_blue'}
                inputClassName={'input_blue'}
                elementType={'select'}
                onSuccess={(data) => setField('locations', data)}
                data={formData?.locations}
                selectOptions={handleCountries()}
                error={clientError?.locations && clientError?.locations}
              />
            </Col>
          </Row>
        </div>

        <div className={styles.load_parameters_button_container}>
          <div className={styles.subscription_panel}>
            <Select
              className="select_container select_container_full"
              defaultValue={'Choose a subscription'}
              size={'large'}
              options={getAllProductsToDisplay(products)}
              onChange={(val) => setField('product_id', val)}
              suffixIcon={<Image src={'/Assets/arrow_select_icon.svg'} alt={'arrow icon'} preview={false} />}
              status={clientError?.product_id && 'error'}
              value={formData?.product_id ? formData?.product_id : undefined}
            />
          </div>
          <div className={styles.button_container}>
            <Button type="primary" className="ant-btn-middle" onClick={() => setParametersModalOpen(true)}>
              Load parameters from a different campaign
            </Button>
            <Button
              loading={createCampaignLoading}
              type="primary"
              className="ant-btn-middle"
              onClick={() => {
                handleCreateCampaign(false);
              }}
            >
              Create
            </Button>
            <Button
              loading={createCampaignLoading}
              type="primary"
              className="ant-btn-middle"
              onClick={() => {
                handleCreateCampaign(true);
              }}
            >
              Save Draft
            </Button>
          </div>
        </div>
      </div>
      <Modal
        open={parametersModalOpen}
        centered
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
        closeIcon={true}
        cancelBtnHidden={true}
        okBtnHidden={true}
        onCancel={() => setParametersModalOpen(false)}
      >
        <div className={styles.active_campaigns_selection_container}>
          <h6>Select Campaign to get parameters from.</h6>
          {handleGetActiveCampaigns()?.length > 0 ? (
            handleGetActiveCampaigns()?.map((item, i) => (
              <div className={styles.campaigns} key={i} onClick={() => handleLoadParamters(item)}>
                <h5>{item?.title}</h5>
                <div className={styles.active}>
                  <div className={styles.dot}></div>
                  <span>{item?.status}</span>
                </div>
              </div>
            ))
          ) : (
            <p>No Active Campaigns</p>
          )}
        </div>
      </Modal>
    </AuthLayout>
  );
};

export default CreateCampaign;
